export const menuItems = {
  'PØLSER & BRØD': [
    { name: 'Rød pølse', price: '28,00' },
    { name: 'Ristet pølse', price: '28,00' },
    { name: 'Ostepølse', price: '35,00' },
    { name: 'Rød knækpølse', price: '35,00' },
    { name: 'Ristet pølse i svøb', price: '35,00' },
    { name: 'Frankfurter', price: '38,00' },
    { name: 'Chili/cheddarpølse', price: '38,00' },
    { name: 'Medisterpølse, almindelig', price: '38,00' },
    { name: 'Medisterpølse, karry', price: '38,00' },
    { name: 'Frankfurter i svøb', price: '45,00' },
    { name: 'Pølsebrød', price: '6,00' },
    { name: 'Kradser', price: '8,00' },
    { name: 'Løgbrød', price: '8,00' },
    { name: 'Fransk Hotdogbrød', price: '8,00' },
    { name: 'Sandwichbolle', price: '8,00' }
  ],
  'FRANSKE HOTDOGS': [
    { name: 'Fransk Hotdog', price: '36,00' },
    { name: 'Fransk Hotdog m/ ostepølse', price: '43,00' },
    { name: 'Fransk Hotdog m/ ristet pølse i svøb', price: '43,00' },
    { name: 'Fransk Hotdog m/ Frankfurter', price: '46,00' },
    { name: 'Fransk Hotdog m/ Frankfurter i svøb', price: '53,00' }
  ],
  'HOTDOGS': [
    { name: 'Alm. Hotdog m/ rød pølse', price: '36,00' },
    { name: 'Ristet Hotdog m/ ristet pølse', price: '36,00' },
    { name: 'Hotdog m/ ostepølse', price: '43,00' },
    { name: 'Ristet Hotdog m/ ristet pølse i svøb', price: '43,00' },
    { name: 'Stor Hotdog m/ frankfurter', price: '46,00' },
    { name: 'Stor Hotdog m/ frankfurter i svøb', price: '53,00' }
  ],
  'SANDWICH': [
    { name: 'Frikadellesandwich', price: '38,00' },
    { name: 'Mørbradsandwich', price: '45,00' },
    { name: 'Bøfsandwich', price: '50,00' },
    { name: 'Flæskestegssandwich', price: '50,00' }
  ],
  'DIVERSE': [
    { name: 'Toast m/ skinke & ost', price: '30,00' },
    { name: 'Hånddelle', price: '20,00' },
    { name: 'Ekstra bøf', price: '30,00' },
    { name: 'Ekstra skive steg (1 skive)', price: '19,00' },
    { name: 'Ekstra ost/bacon pr. stk.', price: '6,00' },
    { name: 'Ekstra bæger rødkål/agurker/dressing', price: '10,00' },
    { name: 'Bähnckes dressinger', price: '50,00' },
    { name: 'Chiliketchup, Bearnaise', price: '70,00' },
    { name: 'Termo/hotdogkasse/take away pr.stk', price: '3,00' }
  ],
  'DRIKKEVARER': [
    { name: 'Æblemost brik', price: '8,00' },
    { name: 'Appelsinjuice brik', price: '8,00' },
    { name: '½ L Kildevand', price: '15,00' },
    { name: 'Sodavand', price: '19,00' },
    { name: 'Cocio lille', price: '22,00' },
    { name: 'Cocio stor', price: '27,00' }
  ],
  'BENNYS COMMERCIALS': [
    { name: 'Kasket med vores logo', price: '50,00' },
    { name: 'T-shirts med vores logo', price: '150,00' }
  ]
};
